import {useTranslation} from "react-i18next";
import InfoBox from "./InfoBox";

import img1 from 'assets/images/home/main_icon-01.png';
import img2 from 'assets/images/home/main_icon-02.png';
import img3 from 'assets/images/home/main_icon-03.png';
import img4 from 'assets/images/home/main_icon-04.png';

export default function Info(props){
  const {t} = useTranslation();
  const imgs = [img1, img2, img3, img4];
  const list = [];
  for(let i = 1; i < 5; i++){
    const title = t(`home.info.title-${i}`)
    const comment = t(`home.info.comment-${i}`)
    const obj = {alt:title, title, comment};
    list.push(obj);
  }
  const children = list.map((i, index) => {
    return <InfoBox key={i.title} image={imgs[index]} alt={i.alt} title={i.title} comment={i.comment}/>
  })

  return (
    <div className="flex justify-center bg-[#273653]">
      <div className={`flex flex-col py-14 px-mobile lg:px-0 lg:w-[1200px]`}>
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between">
          {children[0]}
          {children[1]}
        </div>
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between">
          {children[2]}
          {children[3]}
        </div>
      </div>
    </div>
  );
}